import React from 'react';
import { Box, Typography} from '@mui/material';
import ReportCard from './ReportCard';

export default function ReportsPreview({ reports = [] }) {
  

  if (!Array.isArray(reports) || reports.length === 0) return null;

  

  return (
    <Box mt={5}>
      {Array.isArray(reports) && reports.length > 0 ? (
      <Box
        sx={{
          display: 'flex',
          overflowX: 'auto',
          gap: 2,
          pb: 1,
          scrollSnapType: 'x mandatory',
          WebkitOverflowScrolling: 'touch',
          '&::-webkit-scrollbar': { display: 'none' }, // hides scrollbar
        }}
      >
        {reports.map((report, idx) => (
          <ReportCard report={report} key={report?.report_id || idx} />
        ))}
      </Box>
      ):(
        <Typography 
          variant="h6" 
          fontWeight="bold" 
          className="alert alert-warning" 
          mb={2}
        >
          No Reports Found
        </Typography>

      )}
    </Box>
  );
}
